import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=d32e8b1e&"
import script from "./home2.vue?vue&type=script&lang=js&"
export * from "./home2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports